import { useState } from "react"
import Image from "next/image"
import { useLang } from "hooks/useLang"

type CityKey =
    | "jeddah"
    | "riyadh"
    | "khobar"
    | "alula"
    | "diriyah"
    | "dammam"
    | "abha"
    | "taif"
    | "medina"
    | "yanbu"

const cities: {
    key: CityKey
    image: string
    titleKey: string
    descKey: string
}[] = [
    {
        key: "jeddah",
        image: "/images/jeddah.png",
        titleKey: "jeddah_city",
        descKey: "jeddah_city_desc",
    },
    {
        key: "riyadh",
        image: "/images/riyadh.jpg",
        titleKey: "riyadh_city",
        descKey: "riyadh_city_desc",
    },
    {
        key: "khobar",
        image: "/images/khobar.jpg",
        titleKey: "khobar_city",
        descKey: "khobar_city_desc",
    },
    {
        key: "alula",
        image: "/images/alula.jpg",
        titleKey: "alula_city",
        descKey: "alula_desc",
    },
    {
        key: "diriyah",
        image: "/images/diriyah.jpg",
        titleKey: "diriyah_city",
        descKey: "diriyah_desc",
    },
    {
        key: "dammam",
        image: "/images/dammam.jpg",
        titleKey: "dammam_city",
        descKey: "dammam_desc",
    },
    {
        key: "abha",
        image: "/images/abha.jpg",
        titleKey: "abha_city",
        descKey: "abha_desc",
    },
    {
        key: "taif",
        image: "/images/taif.jpg",
        titleKey: "taif_city",
        descKey: "taif_desc",
    },
    {
        key: "medina",
        image: "/images/medina.jpg",
        titleKey: "medina_city",
        descKey: "medina_desc",
    },
    {
        key: "yanbu",
        image: "/images/yanbu.jpg",
        titleKey: "yanbu_city",
        descKey: "yanbu_desc",
    },
]

const CitiesSection = ({ isLoading }: { isLoading: boolean }) => {
    const { t } = useLang()
    const [cityIndex, setCityIndex] = useState(0)

    if (isLoading) return null

    const city = cities[cityIndex]

    const onRefresh = () => {
        setCityIndex((prev) => (prev === cities.length - 1 ? 0 : prev + 1))
    }

    return (
        <div className="w-full flex flex-col px-8 py-[20px] layout md:max-w-[1220px] gap-4">
            <div className="flex items-center justify-between w-full">
                <span className="text-2xl text-white">{t(city.titleKey)}</span>

                <div
                    className="cursor-pointer hover:opacity-50 transition-all"
                    onClick={onRefresh}
                >
                    <Image
                        src="/svg/refresh.svg"
                        alt="refresh"
                        width={30}
                        height={30}
                        className="w-[30px] h-[30px]"
                    />
                </div>
            </div>

            <div className="flex flex-row items-start gap-[20px]">
                <Image
                    src={city.image}
                    alt={city.key}
                    width={202}
                    height={114}
                    className="w-[202px] aspect-video rounded-[15px] object-cover hidden md:flex"
                />

                <span className="text-white text-[16px]">
                    {t(city.descKey)}
                </span>
            </div>
        </div>
    )
}

export default CitiesSection
